export const fileSourceLoaders = {
  /**
   * JavaScript files loader.
   */
  js: function(src, attrs) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');

    applyAttrs(script, {
      ...attrs,
      ...{
        type: 'text/javascript',
        src,
      },
    });

    head.appendChild(script);
  },
  /**
   * Stylesheet files loader.
   */
  css: function(src, attrs) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');

    applyAttrs(link, {
      ...attrs,
      ...{
        rel: 'stylesheet',
        type: 'text/css',
        href: src,
        media: 'all',
      },
    });

    head.appendChild(link);
  },
};

export function applyAttrs(target, attrs) {
  for (let attr in attrs) {
    if (attrs.hasOwnProperty(attr)) {
      target.setAttribute(attr, attrs[attr]);
    }
  }
}

export function getFileSourceLoader(src) {
  const ext =
    src
      .toLowerCase()
      .split(/[#?]/)[0]
      .split('.')
      .pop()
      .trim() || 'unknown';

  return (
    fileSourceLoaders[ext] ||
    function() {
      throw new Error(`Loader for '${ext}' files not found.`);
    }
  );
}

export function loadFileSource(src, attrs) {
  const fileLoader = getFileSourceLoader(src);
  fileLoader(src, attrs);
}

export function loadFunctionSource(fn) {
  fn();
}

export function loadStyleSource(css, target = document.body) {
  if (target) {
    for (let property in css) {
      if (css.hasOwnProperty(property)) {
        target.style[property] = css[property];
      }
    }
  }
}
